import { AbstractEnum } from "config/enums/abstract-enum";

export class AssistantScenarioStatusEnum extends AbstractEnum {
  public static NOT_STARTED = 0 as const;
  public static IN_PROGRESS = 1 as const;
  public static COMPLETED = 2 as const;
  public static SKIPPED = 3 as const;

  public static choices = {
    [AssistantScenarioStatusEnum.NOT_STARTED]: "Not started",
    [AssistantScenarioStatusEnum.IN_PROGRESS]: "In progress",
    [AssistantScenarioStatusEnum.COMPLETED]: "Completed",
    [AssistantScenarioStatusEnum.SKIPPED]: "Skipped",
  };
}

export type AssistantScenarioStatusEnumType =
  keyof typeof AssistantScenarioStatusEnum.choices;
